import { render, staticRenderFns } from "./SendFeriaTicketForm.vue?vue&type=template&id=f88c8ac4&scoped=true"
import script from "./SendFeriaTicketForm.vue?vue&type=script&lang=ts"
export * from "./SendFeriaTicketForm.vue?vue&type=script&lang=ts"
import style0 from "./SendFeriaTicketForm.vue?vue&type=style&index=0&id=f88c8ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88c8ac4",
  null
  
)

export default component.exports